import React from "react";
import { useSelector } from "react-redux";
import StoreSidebar from "./StoreSidebar";

const StoreLayout = ({ children }) => {
  const isSidebarVisible = useSelector((state) => state.store?.isSidebarVisible);

  return (
    <div className={`min-h-[100vh] py-4 pr-4 w-full transition-all duration-500 ease-in-out ${
      isSidebarVisible ? "pl-[96px]" : "pl-4"
    }`}>
      <StoreSidebar />
      <div className="w-full">
        {children}
      </div>
    </div>
  );
};

export default StoreLayout;
